'use client';

import {
  createContext,
  type ReactNode,
  type RefObject,
  useContext,
  useRef,
  useState,
} from 'react';

interface SiteHeaderContextProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  activeDropdown: string | null;
  setActiveDropdown: (dropdown: string | null) => void;
  siteHeaderMainRef?: RefObject<HTMLDivElement>;
  siteHeaderMenuRef?: RefObject<HTMLDivElement>;
}

export const SiteHeaderContext = createContext<
  SiteHeaderContextProps | undefined
>(undefined);

export function SiteHeaderProvider({ children }: { children?: ReactNode }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const siteHeaderMainRef = useRef<HTMLDivElement>(null);
  const siteHeaderMenuRef = useRef<HTMLDivElement>(null);

  const value: SiteHeaderContextProps = {
    mobileMenuOpen,
    setMobileMenuOpen,
    activeDropdown,
    setActiveDropdown,
    siteHeaderMainRef,
    siteHeaderMenuRef,
  };

  return (
    <SiteHeaderContext.Provider value={value}>
      {children}
    </SiteHeaderContext.Provider>
  );
}

export function useSiteHeader() {
  const context = useContext(SiteHeaderContext);
  if (context === undefined) {
    throw new Error('useSiteHeader must be used within a SiteHeaderProvider');
  }
  return context;
}
